import { store } from '..';

export const STAB = 1;
export const VIERKANTSTAB = 2;
export const VIERKANTROHR = 3;
export const ROHR = 4;
export const TRAEGER = 5;

export const HORIZONTAL = 1;
export const VERTIKAL = 2;
export const SCHWENKRAHMEN = 3;

// --- STATE ------------------------------
export interface ParamentorState {
    busy: number;

    bandmaterialienList: Array<BezeichnungItem>;
    bandbeschichtungenList: Array<BezeichnungItem>;
    formenList: Array<BezeichnungItem>;
    traegerTypenList: Array<BezeichnungItem>;
    traegerAbmessungenList: Array<BezeichnungItem>;
    verguetungsartList: Array<BezeichnungItem>;
    gefuegeartenList: Array<BezeichnungItem>;
    kuehlungsartenList: Array<BezeichnungItem>;
    leistungsvorgabenList: Array<BezeichnungItem>;
    produkteList: Array<BezeichnungItem>;
    vorhandenesSaegebandAusfuehrungenList: Array<Saegeband>;

    maschinenhersteller?: Maschinenhersteller;
    maschine?: Maschine;
    saegebandabmessung?: Saegebandabmessung;
    bandmaterialtyp: number;
    bandbeschichtung: number;

    erzeugnis: Erzeugnis;
    verguetungsart: number;
    gefuegeart: number;

    kuehlungsart: number;
    leistungsvorgabe: number;
    lagenschnitt: boolean;
    anzahlLagen: number;
    anzahlProLage: number;

    vorhandenesSaegeband?: SaegebandProdukt;
    vorhandenesSaegebandAusfuehrung?: Saegeband;

    spannbereichError: boolean;

    produktempfehlungLevel1?: Produktempfehlung;
    produktempfehlungLevel2?: Produktempfehlung;
    produktempfehlungLevel3?: Produktempfehlung;

    produktempfehlungFavoritesList?: ProduktEmpfehlungFavorit[];

    parameterempfehlungLevel1?: Parameterempfehlung;
    parameterempfehlungLevel2?: Parameterempfehlung;
    parameterempfehlungLevel3?: Parameterempfehlung;
    parameterempfehlungVorhandenesSaegeband?: Parameterempfehlung;

    maschinenkosten?: number;
    kostenProBediener?: number;

    preisProBandLevel1?: number;
    preisProBandLevel2?: number;
    preisProBandLevel3?: number;
    preisProBandVorhandenesSaegeband?: number;

    standflaecheLevel1?: number;
    standflaecheLevel2?: number;
    standflaecheLevel3?: number;
    standflaecheVorhandenesSaegeband?: number;

    standflaecheTypLevel1: number;
    standflaecheTypLevel2: number;
    standflaecheTypLevel3: number;
    standflaecheTypVorhandenesSaegeband: number;

    maschinenProBedienderLevel1: number;
    maschinenProBedienderLevel2: number;
    maschinenProBedienderLevel3: number;
    maschinenProBedienderVorhandenesSaegeband: number;

    kostenersparnisLevel1?: Kostenersparnis;
    kostenersparnisLevel2?: Kostenersparnis;
    kostenersparnisLevel3?: Kostenersparnis;
    kostenersparnisVorhandenesSaegeband?: Kostenersparnis;
    sessions: Array<Session>;
}

export const getParamentorState = ():ParamentorState => {
    return store.getState().paramentor;
}

export interface BezeichnungItem {
    id: number;
    label: string;
}

export interface Session {
  id: number;
  maschinenhersteller: number;
  maschine: number;
  werkstoff: number;
  vorhandenesSaegeband: number;
  vorhandenesSaegebandAusfuehrung: number;
}

export interface Maschinenhersteller {
    id: number;
    name: string;
}

export interface Maschine {
    id: number;
    bezeichnung: string;
    schraegestellung: number;
    maschinentyp: number;
    maschinenherstellerId: number;
    maschinenhersteller: string;
    spannbereich: number;
    spannbereichImperial: string;
    saegebandabmessung: string;
    saegebandabmessungId: number;
    schnittgeschwindigkeitMin: string;
    schnittgeschwindigkeitMax: string;
}

export interface Saegebandabmessung {
    id: number;
    bandlaenge: string;
    bandlaengeImperial: string;
}
export interface WerkstoffItem extends BezeichnungItem {
    verguetungsart: number;
}

export interface Erzeugnis {
    form: number;
    durchmesser?: number;
    hoehe?: number;
    wandstaerke?: number;
    traegerTyp?: number;
    traegerAbmessung?: number;
    werkstoff?: WerkstoffItem;
    werkstoffgruppe?: number;
}

export interface SaegebandProdukt {
    id: number;
    label: string;
    level: number;
    image: string;
}

export interface Saegeband {
    bezeichnung: string;
    verzahnung: string;
    saegebandAbmessung: number;
    wikusFamilie: number;
}

export interface Produktempfehlung {
    id: number;
    saegeband: string;
    verzahnung: string;
    saegebandabmessung: string;
    image: string;
    productPageUrl?: string;
    inquiryPageUrl?: string;
}

export interface ProduktEmpfehlungFavorit {
    id: number;
    produktempfehlung_id: number;
    level: number;
}

export interface Parameterempfehlung {
    schnittgeschwindigkeit: number;
    vorschub1: string;
    vorschub2?: string;
    schnittzeit: string;
    spandicke1: string;
    spandicke2?: string;
    kuehlschmierstoff: string;
    schnittleistung: number;
    schnittflaeche: number;
    vorschubReal: number;
    schnittzeitReal: number;
}

export interface Kostenersparnis {
    werkzeugkostenProSchnitt: number;
    maschinenkostenProSchnitt: number;
    gesamtkostenProSchnitt: number;
}
